import { render, staticRenderFns } from "./UserUploadOrDownloadModal.vue?vue&type=template&id=f3551db0&"
import script from "./UserUploadOrDownloadModal.vue?vue&type=script&lang=js&"
export * from "./UserUploadOrDownloadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3551db0')) {
      api.createRecord('f3551db0', component.options)
    } else {
      api.reload('f3551db0', component.options)
    }
    module.hot.accept("./UserUploadOrDownloadModal.vue?vue&type=template&id=f3551db0&", function () {
      api.rerender('f3551db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/UserUploadOrDownloadModal.vue"
export default component.exports